export function getCurrentUrl(pathname: string) {
  return pathname.split(/[?#]/)[0]
}

export function checkIsActive(pathname: string, url: string, storeId: unknown) {
  let current = getCurrentUrl(pathname)

  if(storeId)
  {
    current = current.replace(`/${storeId}`, '');
    url = url.replace(`/${storeId}`, '');
  }

  if(!current || current === '/')
    current = '/home'

  if (!current || !url)
    return false

  if (current === url)
    return true

  if (current.indexOf(url) > -1)
    return true

  return false
}